import {Utilities} from '@shared/utilities/utilities.model';
import {DossierAndWorkingStates, WorkingTypes} from './enums.model';

export class QuotationListInfoModel {
	quotations: QuotationListItem[];

	constructor(model?: any) {
		if (!Utilities.isVoid (model)) {
			this.quotations = [];
			model.quotations.forEach (item => this.quotations.push (new QuotationListItem (item)));
		}
	}
}

export class QuotationListItem {
	commodityId: string;
	createdAt: string;
	fixedConsumablesValue: string;
	id: string;
	sequentialId: string;
	status: string | DossierAndWorkingStates;
	type: WorkingTypes;
	updatedAt: string;
	vatPercentage: string;
	wasteDisposalPercentage: string;
	actions: QuotationActions;
	declinedNote: string;

	constructor(model?: any) {
		if (!Utilities.isVoid (model)) {
			this.commodityId = model.commodity_id;
			this.createdAt = model.created_at;
			this.fixedConsumablesValue = model.fixed_consumables_value;
			this.id = model.id;
			this.sequentialId = model.sequential_id;
			this.status = model.status;
			this.type = model.type;
			this.updatedAt = model.updated_at;
			this.vatPercentage = model.vat_percentage;
			this.wasteDisposalPercentage = model.waste_disposal_percentage;
			this.declinedNote = model.declined_note;
			this.actions = new QuotationActions (model.actions);
		}
	}
}

export class QuotationActions {
	// Operazioni per l'operatore centro
	anotherCanBeCreated: boolean;
	canBeDeleted: boolean;
	canBeEdited: boolean;
	canBeSent: boolean;
	partsCanBeManaged: boolean;
	workingCanFinish: boolean;
	workingCanStart: boolean;
	entry_can_be_removed: boolean;
	entry_warranty_can_be_changed_for_approved: boolean;

	// nuove actions
	canBeDeclined: boolean;
	canBeReApproved: boolean;
	canBeReDeclinded: boolean;
	canBeIntegrated: boolean;
	canBeShipped: boolean;
	canBeManaged: boolean;

	// Operazioni per l'operatore ALD
	canBeApproved: boolean;
	canBeRejected: boolean;
	canBeEditedByAuthority: boolean;
	entry_can_be_removed_by_authority: boolean;
	entry_warranty_can_be_changed_for_approved_by_authority: boolean;
	can_active_invoicing: boolean;

	// Operazioni per il supervisor
	canBeSuperApproved: boolean;
	canBeSuperRejected: boolean;
	canBeSuperDeclined: boolean;
	canBeCanceledSuperReject: boolean;
	canBeDownloadedWoePdf: boolean;
	canBeSentToSupervisor: boolean;
	canBeDissociated: boolean;

	//consip actions
	canBeConsipFlowApproved: boolean;
	canBeConsipFlowRejected: boolean;
	canBeConsipFlowMailSent: boolean;
	canBeConsipFlowExtraFee: boolean;
	canBeBilledWithoutLastIntegration: boolean;
	canBeCFlowPreviewSeen: boolean;


	constructor(model?: any) {
		if (!Utilities.isVoid (model)) {
			// Operazioni per l'operatore centro
			this.anotherCanBeCreated = model.another_can_be_created;
			this.canBeDeleted = model.can_be_deleted;
			this.canBeEdited = model.can_be_edited;
			this.canBeSent = model.can_be_sent;
			this.partsCanBeManaged = model.parts_can_be_managed;
			this.workingCanFinish = model.working_can_finish;
			this.workingCanStart = model.working_can_start;
			this.canBeIntegrated = model.can_be_integrated;
			this.canBeShipped = model.can_be_shipped;
			this.canBeManaged = model.can_be_managed;
			this.entry_can_be_removed = model.entry_can_be_removed;
			this.entry_warranty_can_be_changed_for_approved = model.entry_warranty_can_be_changed_for_approved;

			// Operazioni per l'operatore ALD
			this.canBeApproved = model.can_be_approved;
			this.canBeRejected = model.can_be_rejected;
			this.canBeReApproved = model.can_be_re_approved;
			this.canBeReDeclinded = model.can_be_re_declined;
			this.canBeEditedByAuthority = model.can_be_edited_by_authority;
			this.canBeDeclined = model.can_be_declined;
			this.entry_can_be_removed_by_authority = model.entry_can_be_removed_by_authority;
			this.entry_warranty_can_be_changed_for_approved_by_authority = model.entry_warranty_can_be_changed_for_approved_by_authority;
			this.can_active_invoicing = model.can_active_invoicing;

			// Operazioni per il supervisor
			this.canBeSuperApproved = model.can_be_super_approved;
			this.canBeSuperRejected = model.can_be_super_rejected;
			this.canBeSuperDeclined = model.can_be_super_declined;
			this.canBeCanceledSuperReject = model.can_be_canceled_super_reject;
			this.canBeSentToSupervisor = model.can_be_sent_to_supervisor;
			this.canBeDownloadedWoePdf = model.can_be_downloaded_woe_pdf;


			//consip
			this.canBeConsipFlowApproved = model.can_be_c_flow_approved;
			this.canBeConsipFlowRejected = model.can_be_c_flow_rejected;
			this.canBeConsipFlowMailSent = model.can_be_c_flow_mail_sent;
			this.canBeConsipFlowExtraFee = model.can_be_c_flow_extra_fee;
			this.canBeBilledWithoutLastIntegration = model.can_be_billed_without_last_integration;
			this.canBeCFlowPreviewSeen = model.can_be_c_flow_preview_seen;
			this.canBeDissociated = model.can_be_dissociated;
		}
	}
	
	/**
	 * Converte un oggetto action in un DTO
	 * @param {QuotationActions} actions
	 * @returns {any}
	 */ 
	object2DTO(actions: QuotationActions): any {
		
		return {
			// Operazioni per l'operatore centro
			another_can_be_created               			 : actions.anotherCanBeCreated,
			can_be_deleted               							 : actions.canBeDeleted,
			can_be_edited               							 : actions.canBeEdited,
			can_be_sent               								 : actions.canBeSent,
			parts_can_be_managed               				 : actions.partsCanBeManaged,
			working_can_finish               					 : actions.workingCanFinish,
			working_can_start               					 : actions.workingCanStart,
			can_be_integrated               					 : actions.canBeIntegrated,
			can_be_shipped               							 : actions.canBeShipped,
			can_be_managed               							 : actions.canBeManaged,
			entry_can_be_removed               				 : actions.entry_can_be_removed,
			entry_warranty_can_be_changed_for_approved : actions.entry_warranty_can_be_changed_for_approved,
	
			// Operazioni per l'operatore ALD
			can_be_approved               													: actions.canBeApproved,
			can_be_rejected               													: actions.canBeRejected,
			can_be_re_approved               												: actions.canBeReApproved,
			can_be_re_declined               												: actions.canBeReDeclinded,
			can_be_edited_by_authority               								: actions.canBeEditedByAuthority,
			can_be_declined               													: actions.canBeDeclined,
			entry_can_be_removed_by_authority               				: actions.entry_can_be_removed_by_authority,
			entry_warranty_can_be_changed_for_approved_by_authority : actions.entry_warranty_can_be_changed_for_approved_by_authority,
			can_active_invoicing               											: actions.can_active_invoicing,
	
			// Operazioni per il supervisor
			can_be_super_approved        : actions.canBeSuperApproved,
			can_be_super_rejected        : actions.canBeSuperRejected,
			can_be_super_declined        : actions.canBeSuperDeclined,
			can_be_canceled_super_reject : actions.canBeCanceledSuperReject,
			can_be_sent_to_supervisor    : actions.canBeSentToSupervisor,
			can_be_downloaded_woe_pdf    : actions.canBeDownloadedWoePdf,
	
			//consip
			can_be_c_flow_approved               	 : actions.canBeConsipFlowApproved,
			can_be_c_flow_rejected               	 : actions.canBeConsipFlowRejected,
			can_be_c_flow_mail_sent                : actions.canBeConsipFlowMailSent,
			can_be_c_flow_extra_fee                : actions.canBeConsipFlowExtraFee,
			can_be_billed_without_last_integration : actions.canBeBilledWithoutLastIntegration,
			can_be_c_flow_preview_seen             : actions.canBeCFlowPreviewSeen,
			can_be_dissociated               			 : actions.canBeDissociated,
		};
	}
}
